import { withForm } from 'components/Form';

import SkuCancelConfirmModal from './SkuCancelConfirmModal';

// No syncValidator: the message is pre-filled at open time and is read-only.
// The form's initialValues supply the HTML message body sent to the API.
export default withForm({
  name: 'SKU_CANCEL_NOTIFY_MODAL_FORM',
})(SkuCancelConfirmModal);
